<template>
  <b-row>
    <b-col cols="12">
      <b-jumbotron>
        <b-form @submit="onSubmit">
          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Title:">
            <b-form-input required id="title" v-model.trim="post.title"></b-form-input>
          </b-form-group>
          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Date:">
                <b-form-input required id="DateTime" type="date" v-model.trim="post.DateTime"></b-form-input>
          </b-form-group>

          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Position:">
            <b-form-select required id="position" v-model.trim="post.position">
              <option value="President">President</option>
              <option value="Vice President">Vice President</option>
              <option value="Secretary">Secretary</option>
              <option value="Treasurer">Treasurer</option>
            </b-form-select>
          </b-form-group>

          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Author:">
            <b-form-input required id="Author" v-model.trim="post.Author"></b-form-input>
          </b-form-group>

          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Details:">
            <b-form-textarea required id="details"
                        v-model="post.details"
                        :rows="10"
                        :max-rows="25">
                        {{post.details}}
            </b-form-textarea>
          </b-form-group>

          <b-button type="submit" variant="success" class="submit-btn">Save</b-button>
          <b-btn variant="primary" @click.stop="showpost(key)">Cancel</b-btn>
        </b-form>
      </b-jumbotron>
    </b-col>
  </b-row>
</template>

<script>

import firebase from '../Firebase'
import router from '../router/index.js'

export default {
  name: 'EditPost',
  data () {
    return {
      key: this.$route.params.id,
      post: {},
      scrolled: false
    }
  },
  created () {
    const ref = firebase.firestore().collection('posts').doc(this.$route.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.post = doc.data();
      } else {
        alert("No such document!");
      }
    });
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      const updateRef = firebase.firestore().collection('posts').doc(this.$route.params.id);
      updateRef.set(this.post).then((docRef) => {
        this.key = ''
        this.post.title = ''
        this.post.description = ''
        this.post.author = ''
        router.push({ name: 'ShowPost', params: { id: this.$route.params.id }})
      })
      .catch((error) => {
        alert("Error adding document: ", error);
      });
    },

    showpost (id) {
      router.push({
        name: 'ShowPost',
        params: { id: id }
      })
    }
  }
}
</script>

<style>
  .submit-btn {
    margin-right: 20px;
    width: 70px;
  }
  .jumbotron {
    padding: 2rem;
  }
</style>